import { render } from "./ProjectView.vue?vue&type=template&id=342a279e&scoped=true&ts=true"
import script from "./ProjectView.vue?vue&type=script&lang=ts"
export * from "./ProjectView.vue?vue&type=script&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=342a279e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342a279e"]])

export default __exports__